/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { styled } from '@mui/system';
import PropTypes from 'prop-types';

import { Container, Box, Typography } from '@mui/material';

const HeaderWrapper = styled(Box, {})(({ theme }) => ({
  backgroundColor: 'white',
  display: 'flex',
  position: 'fixed',
  width: '100%',
  height: '55px',
  padding: '10px 20px',
  zIndex: 2,
  justifyContent: 'space-between',
  alignItems: 'center',
  boxShadow: '0px 1px 10px 0px rgba(0,0,0,0.2)',
  '.logo': {
    width: 180,
    height: 'auto',
    // position: 'absolute',
    // right: 20,
  },
  h1: {
    color: theme.palette.gray.main,
    fontSize: '1.2em',
    fontWeight: 'bold',
  },
  h2: {
    // position: 'absolute',
    // left: '45%',
    color: theme.palette.green.main,
  },
}));

const Header = () => (
  <HeaderWrapper>
    <Typography variant="h1">
      SAP Survey
    </Typography>
    <Typography variant="h2">
      Fully utilize the true value of SAP data
    </Typography>
    <img className="logo" src="assets/images/Analytics-By-Qlik-Mark-Horizontal-noRule_RGB.png" alt="Qlik Logo" />
  </HeaderWrapper>
);

// Header.propTypes = {
//   sectionHeading: PropTypes.number,
// };

// Header.defaultProps = {
//   sectionHeading: 0,
// };

export default Header;
